export const linkPrimary = 'linkPrimary';
export const light = 'grey_300';

export const colorMap = {
  linkPrimary,
  light,
} as const;

export type ColorKeys = keyof typeof colorMap;
